<div class="page-container content-w-98">
  <div class="page-head">
    <div style="overflow: auto">
      <div class="page-title">
        <p class="headerName" id="filling-data">
          {{ headerData!.materialName }}
        </p>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showIncorrectFillingNotification">
    <piqet-angular-incorrect-data-notification
      [message]="incorrectFillingValueMessage"
      [isShowButton]="false"
    ></piqet-angular-incorrect-data-notification>
  </ng-container>

  <div [ngClass]="{ 'disabled-project': isScreenDisabled }">
    <div>
      <div class="row" [ngClass]="{ 'disabled-project': checkboxValue || excludeAllMenus }">
        <div
          class="col-md-12"
          *ngrxLet="{
            dataLoaded: (sharedFacade.isLoaded$ | async),
            isClearSearch: (sharedFacade.isClearSearch$ | async)
          } as sharedData"
        >
          <piqet-angular-portlet
            *ngIf="sharedData.dataLoaded"
            [class]="'detail-cell-renderer fixedHeight'"
            [columnDefs]="columnDefs"
            [frameworkComponents]="frameworkComponents"
            [headerBtn]="fillingDataWithComponent?.length > 0 ? 'Edit Filling' : 'Add Filling'"
            [gridName]="'Filling List'"
            [gridData]="fillingDataWithComponent"
            [createAccess]="showEdit"
            [pageNo]="$any(fillDataList)?.draw"
            [hideSideBar]="isHideSideBar"
            (openBtnModal)="addFillDataModal(packageScenarioId, fillingId, 'Add filling')"
            [searchInputSize]="true"
            [hideSearch]="true"
            [isClearSearch]="sharedData.isClearSearch"
          ></piqet-angular-portlet>
        </div>
      </div>
    </div>
  </div>
  <piqet-angular-navigation-button [config]="navigationConfig"> </piqet-angular-navigation-button>
</div>
